import * as ko from "knockout";
export class request_type {
  request_type: KnockoutObservable<string>;
  task_type: KnockoutObservable<string>;
  role_name: KnockoutObservable<string>;
  description: KnockoutObservable<string>;
  req_type_number: KnockoutObservable<string>;
  message_id: KnockoutObservable<string>;
  req_categories: KnockoutObservable<string>;
  is_model_visible: KnockoutObservable<string>;
  is_model_required: KnockoutObservable<string>;
  is_sn_visible: KnockoutObservable<string>;
  is_sn_required: KnockoutObservable<string>;

  constructor(item) {
    this.request_type = ko.observable(item.request_type);
    this.task_type = ko.observable(item.task_type);
    this.role_name = ko.observable(item.role_name);
    this.description = ko.observable(item.description);
    this.req_type_number = ko.observable(item.description);
    this.message_id = ko.observable(item.message_id);
    this.req_categories = ko.observable(item.req_categories);
    this.is_model_visible = ko.observable(item.is_model_visible);
    this.is_model_required = ko.observable(item.is_model_required);
    this.is_sn_visible = ko.observable(item.is_sn_visible);
    this.is_sn_required = ko.observable(item.is_sn_required);
  }
}
